import { z } from 'zod';
/**
 * 客戶資訊快照 Schema
 * 用於 orders.customer_snapshot，儲存訂單成立時的客戶資訊
 * 即使客戶資訊後來變更，訂單仍保留當時的資訊
 */
export const CustomerSnapshotSchema = z.object({
    name: z.string().min(1).describe('客戶姓名'),
    phone: z.string().optional().nullable().describe('客戶電話'),
    points: z.number().int().min(0).describe('當下累積點數'),
    level: z.string().optional().nullable().describe('會員等級（如果有）'),
    shipping_address: z.object({
        name: z.string().min(1).describe('收件人姓名'),
        phone: z.string().optional().describe('收件人電話'),
        address_line1: z.string().min(1).describe('地址第一行（街道地址）'),
        address_line2: z.string().optional().describe('地址第二行（樓層、室號等）'),
        city: z.string().min(1).describe('城市'),
        district: z.string().optional().describe('區/鄉鎮'),
        postal_code: z.string().optional().describe('郵遞區號'),
        country: z.string().default('Taiwan').describe('國家（預設：Taiwan）'),
    }).optional().nullable().describe('當時的配送地址'),
}).passthrough() // 允許額外欄位以支援未來擴展
    .nullable()
    .optional()
    .describe('客戶資訊快照（JSONB 格式）');
